import { useState } from "react";
import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

interface IUseFeaturesFormulario {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const UseFeaturesFormulario = ({ setOpenModal }: IUseFeaturesFormulario) => {
  const { valuesInputsModalidade } = useContextComissoes();
  const { handleGetAlert } = useLayoutMainContext();

  const [loading, setLoading] = useState(false);

  const { setAttTable, attTable, idTable, id, } =
    useConfigPageContext();

  const handleCreate = async () => {
    if (!valuesInputsModalidade.name)
      return handleGetAlert({ message: `Digite uma modalidade` });

    setLoading(true);

    return api
      .post("/comissoes/modalidade", valuesInputsModalidade)
      .then((res) => {
        handleGetAlert({ message: res.data.message });
        setAttTable((item) => !item);
        setOpenModal(false);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  const handleEdit = () => {
    if (!valuesInputsModalidade.name)
      return handleGetAlert({ message: `Digite uma modalidade` });

    setLoading(true);

    return api
      .put(`/comissoes/modalidade/${id}`, valuesInputsModalidade)
      .then((res) => {
        setAttTable((item) => !item);
        handleGetAlert({ message: res.data.message });
        setOpenModal(false);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmit = () => {
    if (idTable) {
      handleEdit();
    } else {
      handleCreate();
    }
  };

  return { handleSubmit, loading };
};
